<template>
  <SimpleComparisonRow
    no-border
    no-padding-top
    :data="data"
    :number-products="numberProducts"
    :index="index"
    :no-highlight="noHighlight"
    class="simple-comparison-row-images"
  >
    <template v-slot="{ columnData, index }">
      <div class="similar-comparison-img-info-container">
        <a :href="localePath('/' + columnData.slug)"
           @click="onSimilarProductClicked(columnData.name)"
        >
          <span class="similar-comparison-img-container">
            <TheImage
              profile="thumb-90"
              :image="columnData.value"
              :alt="columnData.value.title"
            />
          </span>
          <span class="similar-comparison-shoe-name">{{ columnData.name }}</span>
        </a>
        <div v-if="index !== 0" class="similar-comparison__remove-product">
          <CrossIcon
            height="35px"
            width="35px"
            @click.native="simpleComparison.removeProduct({ productId: $event.id, index, productName: columnData.name })"
          />
        </div>
      </div>
    </template>
    <template v-if="!positionSticky" v-slot:emptySlot>
      <div
        class="similar-comparison-img-info-container similar-comparison-img-info-container__empty-slot"
        @click="simpleComparison.openSearchModal('Images')"
      >
        <span class="similar-comparison-img-container">
          <IconShoeSilhouette class="simple-comparison-img-icon" />
          <span class="similar-comparison-img-plus">+</span>
        </span>
        <span class="similar-comparison-img-label">+ {{ $t('product.comparison.add_product') }}</span>
      </div>
    </template>
  </SimpleComparisonRow>
</template>

<script setup>
import SimpleComparisonRow from '@/components/shared/simple-comparison/SimpleComparisonRow';
// import SimpleComparisonProductsSlider from '@/components/shared/simple-comparison/SimpleComparisonProductsSlider';
import CrossIcon from '@/components/icons/awesome-font/CrossIcon';
import IconShoeSilhouette from '@/components/icons/product/IconShoeSilhouette';
import { useSimpleComparisonStore } from "~/stores/simpleComparison";
import { usePageStore } from "~/stores/page";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  numberProducts: {
    type: Number,
    default: 4,
  },
  index: {
    type: Number,
    default: 0,
  },
  noHighlight: {
    type: Boolean,
    default: false,
  },
})

const { $gaEvents } = useNuxtApp();

const simpleComparison = useSimpleComparisonStore();
const page = usePageStore();

const positionSticky = ref(false);

function onSimilarProductClicked(name) {
  if (page.type === 'product') {
    $gaEvents.productSimilarProductClicked(name, props.index + 1);
  }

  if (page.type === 'buying_guide') {
    $gaEvents.guideSimilarProductClicked(name, props.index + 1);
  }
}

onMounted(() => {
  const element = useCurrentElement();

  const observer = new IntersectionObserver(
    () => {
      const { top } = element.value.getBoundingClientRect();
      positionSticky.value = top < 0;
    },
    {
      rootMargin: '-1px 0px 0px 0px',
      threshold: [1],
    },
  );

  observer.observe(element.value);
})
</script>

<style lang="scss" scoped>
.simple-comparison-row-images {
  position: sticky;
  top: $top_header_offset;
  background: #fff;
  z-index: 2;

  @media(max-width: $break_md_under) {
    position: relative;
    top: 0;
  }

  :deep(.similar-comparison-data) {
    border-bottom: 0.09rem solid #ccc;
    padding: 0 0 0.5rem;
  }
  .similar-msg-container {
    min-height: 45px;
    margin: 30px 0;
  }
  .similar-comparison-img-info-container {
    min-height: 119px;
    position: relative;
    // padding-right: 25px;
    .similar-comparison-img-container {
      display: flex;
      align-items: flex-end;
      img {
        display: inline-block;
        object-fit: contain;
        aspect-ratio: 3/2;
      }
    }

    .similar-comparison-shoe-name, .similar-comparison-img-label {
      display: inline-block;
      padding: 0 0.5rem;
      margin-top: 0.5rem;
      line-height: 2rem;
      width: 100%;
    }

    .similar-comparison-shoe-name:hover {
      text-decoration: underline;
    }

    .similar-comparison__remove-product {
      position: absolute;
      top: 1px;
      right: 3px;
      width: 24px;
      height: 24px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        top: 0;
      }
    }
  }

  .similar-comparison-img-info-container__empty-slot {
    text-align: center;

    .similar-comparison-img-container {
      position: relative;
      padding-right: 0;
      justify-content: center;

      .similar-comparison-img-plus {
        position: absolute;
        bottom: 11px;
        left: calc(50% - 4px);
        font-size: 30px;
      }
    }
    &:hover {
      .simple-comparison-img-icon {
        :deep() {
          path {
            fill: #E9E9E9;
          }
        }
      }
      .similar-comparison-img-label {
        text-decoration: underline;
      }
    }
  }
}
</style>
